import { connect } from "react-redux";
import { getListDuNoNhanVay } from "actions/DuNoNhanVay";
import { DuNoNhanVay } from "components/BaoCao/DuNoNhanVay";

const mapStateToProps = (state) => ({
  DuNoNhanVay: state.DuNoNhanVay,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListDuNoNhanVay: (dataSearch) => dispatch(getListDuNoNhanVay(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuNoNhanVay);
